import GoogleFont from './GoogleFont'
import TypographyStyle from './TypographyStyle'

module.exports = {
  GoogleFont,
  TypographyStyle,
}



/** WEBPACK FOOTER **
 ** /Users/kylemathews/programs/typography.js/packages/react-typography/src/index.js
 **/